module.exports = __webpack_public_path__ + "static/img/img-home-co-18.95c78e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-18.png
// module id = JkMC
// module chunks = 1